import EntityModel from '@/common/models/entity-model';
import CreditMemoAllocationModel from '@/common/models/credit-memo-allocation';

export default class CreditMemoModel extends EntityModel {
    hydrate({
        id = null,
        customerId = null,
        organizationId = null,
        number = null,
        type = null,
        currency = null,
        totalCredit = null,
        unusedCredit = null,
        taxCredit = null,
        shippingCredit = null,
        outsideCredit = null,
        generalAdjustmentCredit = null,
        allocations = [],
        originTransactionIds = [],
        refunds = [],
        reversals = [],
        reason = null,
        status = null,
        createdTime = null,
        updatedTime = null,
        revision = null,
    } = {}) {
        this.id = id;
        this.customerId = customerId;
        this.organizationId = organizationId;
        this.number = number;
        this.type = type;
        this.currency = currency;
        this.totalCredit = totalCredit;
        this.unusedCredit = unusedCredit;
        this.taxCredit = taxCredit;
        this.shippingCredit = shippingCredit;
        this.outsideCredit = outsideCredit;
        this.generalAdjustmentCredit = generalAdjustmentCredit;
        this.allocations = allocations.map(allocation => new CreditMemoAllocationModel(allocation));
        this.refunds = refunds;
        this.reversals = reversals;
        this.originTransactionIds = originTransactionIds;
        this.reason = reason;
        this.status = status;
        this.createdTime = createdTime;
        this.updatedTime = updatedTime;
        this.revision = revision;
    }

    get hasItems() {
        const reducer = (accumulator, allocation) => accumulator + allocation.items.length;
        const itemCount = this.allocations.reduce(reducer, 0);

        return itemCount > 0 || this.generalAdjustmentCredit !== null;
    }

    get hasAllocations() {
        return this.allocations.length > 0;
    }

    getAmountAllocatedToInvoice(invoiceId) {
        const [allocation] = this.allocations.filter(item => item.invoiceId === invoiceId);

        return allocation ? allocation.credit : 0;
    }

    getTotalRefundTransactionAmount(transactionId) {
        const amount = this.refunds
            .filter(refund => refund.transactionId === transactionId)
            .reduce((accumulator, reversal) => accumulator + reversal.amount, 0);

        return amount || 0;
    }

    getTotalReversalTransactionAmount(transactionId) {
        const reversedCredit = this.reversals
            .filter(reversal => reversal.transactionId === transactionId)
            .reduce((accumulator, reversal) => accumulator + reversal.reversedCredit, 0);

        return reversedCredit || 0;
    }

    get numberLabel() {
        return `${this.number}`.padStart(6, '0');
    }

    get reversalTransactionIds() {
        return [...new Set(this.reversals.map(reversal => reversal.transactionId))];
    }

    get refundTransactionIds() {
        return [...new Set(this.refunds.map(refund => refund.transactionId))];
    }
}
